import { useHistory, useLocation } from "react-router-dom";
import { Card, Flex, FullscreenTakeover, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Column } from "@jsq/ds/layouts";
import { Colors } from "@jsq/ds/styles";
import { BackButtonWithinForm } from "../../../Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/BackButtonWithinForm";
import { accountTypeLabel, containerStyle, dividerStyle } from "./styles_vanilla.css";

interface Props {
  baseUrl?: string;
  isPaymentBeneficiaryFlow?: boolean;
}

const ProfileTypeSelector = ({ baseUrl, isPaymentBeneficiaryFlow = false }: Props) => {
  const history = useHistory();
  const location = useLocation();

  const onExit = () => {
    if (baseUrl) {
      history.push(baseUrl);
    }
  };

  const onProfileTypeSelected = (profileType: "individual" | "entity") => {
    history.push({
      pathname: `${location.pathname}/${profileType}`,
      search: location.search,
    });
  };

  return (
    <FullscreenTakeover.Body>
      <Column size="lg">
        <Card data-testid="fundraisingAndOwnershipCard">
          {baseUrl && isPaymentBeneficiaryFlow && (
            <BackButtonWithinForm onClick={onExit} displayText="All payment beneficiaries" />
          )}
          <Text marginBottom="sm" variant="h3">
            {isPaymentBeneficiaryFlow ? "Add payment beneficiary" : "Add owner or controller"}
          </Text>
          <Text className={accountTypeLabel}>Select an account type</Text>
          <div
            className={containerStyle}
            role="button"
            onClick={() => onProfileTypeSelected("individual")}
            tabIndex={0}
            onKeyDown={() => {}}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <div>
                <Text data-testid="optionTitle" variant="strong-lg">
                  Individual
                </Text>
              </div>
              <Icon
                type="chevron-right"
                color={Colors.Neutral600}
                variant="outline"
                size="large"
              />
            </Flex>
          </div>
          <div className={dividerStyle} />
          <div
            className={containerStyle}
            role="button"
            onClick={() => onProfileTypeSelected("entity")}
            tabIndex={0}
            onKeyDown={() => {}}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <div>
                <Text data-testid="optionTitle" variant="strong-lg">
                  Entity
                </Text>
              </div>
              <Icon
                type="chevron-right"
                color={Colors.Neutral600}
                variant="outline"
                size="large"
              />
            </Flex>
          </div>
          <div className={dividerStyle} />
        </Card>
      </Column>
    </FullscreenTakeover.Body>
  );
};

export default ProfileTypeSelector;
